import React from "react";

/*
    - ihoDesignSystem
*/
import { Alert, Container, Grid, Image } from "@iho-design-system/Loader";

/*
    - component
*/
import List from "../components/reserve/List";
import Toolbar from "../components/reserve/Toolbar";
/*
    - icon
*/
import LoadingCustomSVG from "../assets/images/icons/loading-custom.svg";
/*
    - api
*/
import getAPI from "../api/get";

const Reserve = () => {
  /*
        - defaultData
    */
  const [reserveData, setResesrveData] = React.useState({
    reserveFilters: "",
    reserves: "",
    userCompaniesHistory: "",
  });
  const [advancedSearchParameters, setAdvancedSearchParameters] =
    React.useState({
      ReserveType: 1,
      CityId: 0,
      HotelId: 0,
      StartDate: "",
      InsertDate: "",
    });
  const [reloadReseverStatus, setReloadReseverStatus] = React.useState("");

  const [shouldLoadFilters, setShouldLoadFilters] = React.useState(false);
  /*
        - alert
    */
  const [alert, setAlert] = React.useState("");
  const [alertColor, setAlertColor] = React.useState("success");
  const [alertStatus, setAlertStatus] = React.useState("d-none");
  const alertProps = (config) => {
    setAlert(config[1]);
    setAlertColor(config[0]);
    setAlertStatus("d-flex");
    setTimeout(() => {
      setAlertStatus("d-none");
    }, 2500);
  };
  const [isLoading, setIsLoading] = React.useState(false);

  /*
        - fetchData
    */
  React.useEffect(() => {
    const fetchInitialData = async () => {
      const reserves = await getAPI({
        ctrl: "UserProfile",
        method: "Reserves",
        query: "?PageIndex=1&PageSize=10",
      });

      setResesrveData((prev) => ({
        ...prev,
        reserves,
      }));
    };

    fetchInitialData();
  }, [reloadReseverStatus]);

  React.useEffect(() => {
    if (!shouldLoadFilters || reserveData.reserveFilters) return;

    const fetchFilters = async () => {
      const filters = await getAPI({
        ctrl: "UserProfile",
        method: "ReserveFilters",
        query: "",
      });

      setResesrveData((prev) => ({
        ...prev,
        reserveFilters: filters,
      }));
    };

    fetchFilters();
  }, [shouldLoadFilters]);

  /*
        - reloadReserveProps
    */
  const reloadReserveProps = (reloadReserveProps) => {
    setResesrveData({
      reserveFilters: "",
      reserves: "",
      userCompaniesHistory: "",
    });
    setAdvancedSearchParameters({
      ReserveType: 1,
      CityId: 0,
      HotelId: 0,
      StartDate: "",
      InsertDate: "",
    });
    setReloadReseverStatus(reloadReserveProps);
  };

  /*
        - reserveIdSearchProps
    */
  const reserveIdSearchProps = async (reserveIdSearchProps) => {
    let parameters = {
      ctrl: "UserProfile",
      method: "Reserves",
      query: "",
    };
    if (reserveIdSearchProps !== "") {
      parameters.query = `?PageIndex=1&PageSize=10&ReserveId=${reserveIdSearchProps}`;
    }
    setResesrveData({
      ...reserveData,
      reserves: await getAPI(parameters),
    });
  };

  /*
        - advancedSearchProps
    */
  const advancedSearchProps = async (advancedSearchProps) => {
    setIsLoading(true);

    let parameters = {
      ctrl: "UserProfile",
      method: "Reserves",
      query: `?PageIndex=1&PageSize=10&ReserveType=${advancedSearchProps.ReserveType}&CityId=${advancedSearchProps.CityId}&HotelId=${advancedSearchProps.HotelId}&StartDate=${advancedSearchProps.StartDate}&insertDate=${advancedSearchProps.InsertDate}`,
    };

    setAdvancedSearchParameters(advancedSearchProps);

    const data = await getAPI(parameters);
    setResesrveData({
      ...reserveData,
      reserves: data,
    });

    setIsLoading(false);
  };

  /*
        - paginationProps
    */
  const paginationProps = async (paginationProps) => {
    let parameters = {
      ctrl: "UserProfile",
      method: "Reserves",
      query: "",
    };
    if (
      Math.ceil(
        reserveData.reserves.data.TotalItems /
          reserveData.reserves.data.PageSize
      ) >=
        reserveData.reserves.data.PageIndex + paginationProps &&
      reserveData.reserves.data.PageIndex + paginationProps >= 1
    ) {
      parameters.query = `?PageIndex=${
        reserveData.reserves.data.PageIndex + paginationProps
      }&PageSize=10&ReserveType=${
        advancedSearchParameters.ReserveType
      }&CityId=${advancedSearchParameters.CityId}&HotelId=${
        advancedSearchParameters.HotelId
      }&StartDate=${advancedSearchParameters.StartDate}&insertDate=${
        advancedSearchParameters.InsertDate
      }`;
      setResesrveData({
        ...reserveData,
        reserves: await getAPI(parameters),
      });
    }
  };

  /*
        - componentData
    */
  let toolbarData = [];
  toolbarData.reserveFilters = reserveData.reserveFilters;

  let listData = [];
  listData.reserves = reserveData.reserves;
  listData.userCompaniesHistory = reserveData.userCompaniesHistory;

  return (
    <React.Fragment>
      <Container size="lg">
        <Grid>
          <Grid.Wrapper>
            <Grid.Item className={`pr-0 pl-0`} size="col-12">
              <Toolbar
                props={toolbarData}
                reserveIdSearchProps={reserveIdSearchProps}
                advancedSearchProps={advancedSearchProps}
                reloadReserveProps={reloadReserveProps}
                onOpenAdvancedSearch={() => setShouldLoadFilters(true)}
              />
            </Grid.Item>
            <Grid.Item size="col-12">
            {isLoading ? (
                <div style={{
                  display : "flex",
                  justifyContent : "center"
                }}>
                  <Image
                    className={`d-inline`}
                    src={LoadingCustomSVG}
                    ms={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </div>
              ) : (
                <List
                  props={listData}
                  alertProps={alertProps}
                  paginationProps={paginationProps}
                  reloadReserveProps={reloadReserveProps}
                />
              )}
            </Grid.Item>
          </Grid.Wrapper>
        </Grid>
      </Container>
      <Alert
        className={`alert ${alertStatus}`}
        color={alertColor}
        ms={{
          bottom: "75px !important",
        }}
      >
        {alert}
      </Alert>
    </React.Fragment>
  );
};

export default Reserve;
